<template>
    <section class="container margin-both-sm" v-if="data && data.content">
        <HtmlContent class="no-padding" :html="data.content" />
    </section>
</template>

<script>
import HtmlContent from '@/components/elements/HtmlContent'

export default {
    props : ['data'],
    components: {
        HtmlContent
    }
}
</script>

<style lang="scss">
.module-content_block{
    max-width: 800px;
    .html-content{
        margin: 0 auto;
    }
}
</style>